var map = {
	"./introduction1.png": 2375,
	"./introduction2.png": 3900,
	"./introduction3.png": 437,
	"./introductionEn1.png": 1496,
	"./introductionEn2.png": 5987,
	"./introductionEn3.png": 778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8287;